import { createSlice } from "@reduxjs/toolkit";

const initialProductState = {
  listLoading: false,
  actionsLoading: false,
  error: null,
  totalCount: 0,
  totalPages: 1,
  requestedQuoteList: [],
  requestedQuote: [],
  detailedQuote: [],
  requestHistory: [],
  historyTotalPages: 1,
  page: 1,
  requestedProduct: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const orderSlice = createSlice({
  name: "orders",
  initialState: initialProductState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    callSuccess: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    ordersFetched: (state, action) => {
      const { totalPages, totalCount, requestedQuoteList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.requestedQuoteList = requestedQuoteList;
      state.totalCount = totalCount;
      state.totalPages = totalPages;
    },
    requestedQuote: (state, action) => {
      // const { requestedQuote } = action.payload;
      state.error = null;
      state.requestedQuote = action.payload;
      state.listLoading = false;
    },
    detailedOrder: (state, action) => {
      state.error = null;
      state.detailedQuote = action.payload.detailedQuote[0];
      state.listLoading = false;
    },
    requestHistoryFetched: (state, action) => {
      const { requestHistory, totalPages, page } = action.payload;
      state.requestHistory = requestHistory;
      state.listLoading = false;
      state.historyTotalPages = totalPages;
      state.page = page;
      state.error = null;
    },
    updateRequest: (state, action) => {
      let { requestedProduct } = action.payload;
      delete requestedProduct.estimateSendByUserDetails;
      delete requestedProduct.assignedSalesUserDetails;

      state.error = null;
      state.requestedProduct = {
        ...state.requestedProduct,
        ...requestedProduct,
      };
      state.listLoading = false;
      state.actionsLoading = false;
    },
  },
});
